import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { HeaderBar } from '../components/ui';
import { motion } from 'framer-motion';
import './RoleSelection.css';

function RoleSelection() {
  const navigate = useNavigate();
  const { eventData } = useApp();

  useEffect(() => {
    if (!eventData) {
      navigate('/');
    }
  }, [eventData, navigate]);

  const handleRoleSelect = (role) => {
    if (role === 'driver') {
      navigate('/offer-carpool');
    } else {
      navigate('/need-carpool');
    }
  };

  if (!eventData) return null;

  return (
    <div className="role-selection-page">
      <HeaderBar />
      
      <div className="role-selection-main">
        <motion.div 
          className="role-selection-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          {/* Header */}
          <div className="role-header">
            <span className="event-badge">🎉 {eventData.eventName}</span>
            <h1>How would you like to participate?</h1>
            <p>Choose your role for this event</p>
          </div>
          
          {/* Role Cards */}
          <div className="role-cards">
            <motion.div 
              className="role-card role-card-driver"
              onClick={() => handleRoleSelect('driver')}
              whileHover={{ scale: 1.02, y: -4 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="role-card-icon">🚗</div>
              <div className="role-card-content">
                <h2>Offer a Ride</h2>
                <p>I have a car and can give others a ride to the event</p>
              </div>
              <div className="role-card-arrow">→</div>
            </motion.div>
            
            <motion.div 
              className="role-card role-card-passenger"
              onClick={() => handleRoleSelect('passenger')}
              whileHover={{ scale: 1.02, y: -4 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="role-card-icon">🙋</div>
              <div className="role-card-content">
                <h2>Find a Ride</h2>
                <p>I need a ride to the event and looking for a carpool</p>
              </div>
              <div className="role-card-arrow">→</div>
            </motion.div>
          </div>
          
          {/* Back Button */}
          <div className="role-actions">
            <button className="back-btn" onClick={() => navigate('/')}>
              ← Back to Home
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default RoleSelection;
